<div class="accent flex items-center justify-between w-full">
    <span class="p-4 h1 pt-4" mat-dialog-title>
        <strong>
            {{
                "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.TITLE" | translate
            }}
        </strong>
    </span>

    <div>
        <a (click)="close()">
            <mat-icon>close</mat-icon>
        </a>
    </div>
</div>
<!-- <div
    *ngIf="showSuccessMessage"
    style="
        background-color: greenyellow;
        z-index: 1000;
        position: fixed;
        padding: 10px;
        height: 40px;
        display: block;
        right: 30px;
        top: 70px;
    "
>
    {{
        "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.MESSAGES.DELIVERY_SAVE_SUCCESS"
            | translate
    }}
</div>
<div
    *ngIf="showErrorMessage"
    style="
        background-color: rgb(255, 64, 47);
        z-index: 1000;
        position: fixed;
        padding: 10px;
        height: 40px;
        display: block;
        right: 30px;
        top: 70px;
    "
>
    {{
        "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.MESSAGES.DELIVERY_SAVE_ERROR"
            | translate
    }}
</div> -->

<div class="p-2">
    <div *ngIf="poItem != null">
        <span>
            {{
                "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.REQUESTED_QUANTITY"
                    | translate
            }}
            &nbsp;:&nbsp;{{ poItem.quantity }}</span
        >
        &nbsp;
        <span>
            <span *ngIf="poItem.unit == pOUnitEnum.KG"
                >{{
                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.KG" | translate
                }}
            </span>
            <span *ngIf="poItem.unit == pOUnitEnum.TONNE"
                >{{
                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.TONNE"
                        | translate
                }}
            </span> </span
        ><br />
        <span
            >{{
                "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.REMAINING_QUANTITY"
                    | translate
            }}
            &nbsp;:&nbsp;{{ remainingQuantity }}</span
        >
        &nbsp;
        <span>
            <span *ngIf="poItem.unit == pOUnitEnum.KG"
                >{{
                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.KG" | translate
                }}
            </span>
            <span *ngIf="poItem.unit == pOUnitEnum.TONNE"
                >{{
                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.TONNE"
                        | translate
                }}
            </span>
        </span>
        <br />
    </div>
    &nbsp;
    <div>
        <button class="btn btn-primary" (click)="addItem()">Add Batch</button>
    </div>
    <br />
    <div *ngIf="batchList.length > 0">
        <table class="table table-striped tablefixed">
            <thead>
                <tr>
                    <th>
                        {{
                            "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.TABLE_HEADERS.BATCH_LOT_NUMBER"
                                | translate
                        }}
                    </th>
                    <th>
                        {{
                            "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.TABLE_HEADERS.MANUFACTURING_DATE"
                                | translate
                        }}
                    </th>
                    <th>
                        {{
                            "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.TABLE_HEADERS.EXPIRY_DATE"
                                | translate
                        }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let batch of batchList">
                    <td>{{ batch.batchNumber }}</td>
                    <td>{{ batch.manufactureDate | date: "mediumDate" }}</td>
                    <td>{{ batch.expiryDate | date: "mediumDate" }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <form [formGroup]="deliveryForm">
        <!-- <mat-radio-group formControlName="status" aria-label="Select an option">
      <div>
        <mat-radio-button [value]="1">Partially Completed
        </mat-radio-button>
      <br>
        <mat-radio-button [value]="2">
          Completed</mat-radio-button>
      </div>

    </mat-radio-group> -->
        <div formArrayName="poItemDeliveryDtos">
            <div
                *ngFor="let poItem of getPoItemControl.controls; let i = index"
            >
                <div [formGroupName]="i" class="po-item">
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.TABLE_HEADERS.RECEIVED_QUANTITY"
                                | translate
                        }}</mat-label>
                        <input
                            matInput
                            type="number"
                            formControlName="receivedQuantity"
                        />
                    </mat-form-field>

                    &nbsp;

                    <mat-form-field appearance="outline" class="pr-4 pl-4">
                        <mat-label>{{
                            "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.TABLE_HEADERS.BATCH_LOT_NUMBER"
                                | translate
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="batchNumber"
                            (change)="checkIfBatchPresent($event, poItem)"
                        />
                    </mat-form-field>
                    &nbsp;
                    <mat-form-field appearance="outline">
                        <input
                            matInput
                            readonly
                            formControlName="manufactureDate"
                            [matDatepicker]="dp1"
                            placeholder="{{
                                'PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.TABLE_HEADERS.MANUFACTURING_DATE'
                                    | translate
                            }}"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="dp1"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #dp1 disabled="false"></mat-datepicker>
                    </mat-form-field>
                    &nbsp;
                    <mat-form-field appearance="outline">
                        <input
                            matInput
                            readonly
                            formControlName="expiryDate"
                            [matDatepicker]="dp2"
                            placeholder="{{
                                'PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.TABLE_HEADERS.EXPIRY_DATE'
                                    | translate
                            }}"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="dp2"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #dp2 disabled="false"></mat-datepicker>
                    </mat-form-field>
                    &nbsp; &nbsp;

                    <!-- <mat-icon *ngIf="i==0" (click)="addItem()">add</mat-icon> -->
                    &nbsp;
                    <button
                        mat-raised-button
                        *ngIf="i != 0"
                        (click)="deleteItem(i)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </form>

    <div class="p-8" style="text-align: right">
        <button
            class="btn btn-default"
            [disabled]="!deliveryForm.valid"
            (click)="saveDelivery(deliveryForm.value)"
        >
            {{
                "PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.SAVE_BUTTON"
                    | translate
            }}
        </button>
    </div>

    <ngx-loading [show]="isLoading"></ngx-loading>
</div>
